import React from "react";
import { connectionTypeIcons, statusImages } from "../../../resources/js/icons";
import P from "../../../shared/typography/P";

const OngoingStatusCard = (props) => {
    return (
        <div>
            <div className="pb-1.5 mb-1.5 border-b border-blue-200">
                <div className="flex justify-between gap-1">
                    <div className="flex gap-1 items-center">
                        <img
                            src={connectionTypeIcons[props?.type]}
                            alt={props?.type}
                            className="h-3"
                        />
                        <P className="text-blue font-medium text-sm line-clamp-1">
                            {props?.plantName}
                        </P>
                    </div>
                    <P className="text-primary font-medium text-sm line-clamp-1">
                        {props?.plantSize}KWp
                    </P>
                </div>
                <div className="flex justify-between items-center mt-1">
                    <div className="flex items-center">
                        <P className="text-xs font-vietnam text-gray-370 capitalize">
                            Proposal State: {props?.stage}
                        </P>
                        {props?.stage ? (
                            <img
                                src={statusImages[props?.stage.toLowerCase()]}
                                alt="fire"
                                className="h-2"
                            />
                        ) : (
                            "-"
                        )}
                    </div>
                    <P
                        type="button"
                        onClick={props.onClick}
                        className="text-xs text-blue"
                    >
                        Follow-up: {props?.followups?.length}
                    </P>
                </div>
            </div>
        </div>
    );
};

export default OngoingStatusCard;
